import React, { useState, useEffect } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [footerSettings, setFooterSettings] = useState({
    footer_address: "Kaiser's Bridge, Benitses, Corfu, Greece",
    footer_phone: "+30 26610 72120",
    footer_email: "info@corfuhotelkaiser.com",
    footer_copyright: "Kaiser Bridge Hotel"
  });

  useEffect(() => {
    const fetchFooterSettings = async () => {
      try {
        const response = await fetch(`${API}/api/public/payment-settings`);
        if (response.ok) {
          const data = await response.json();
          setFooterSettings({
            footer_address: data.footer_address || "Kaiser's Bridge, Benitses, Corfu, Greece",
            footer_phone: data.footer_phone || "+30 26610 72120",
            footer_email: data.footer_email || "info@corfuhotelkaiser.com",
            footer_copyright: data.footer_copyright || "Kaiser Bridge Hotel"
          });
        }
      } catch (error) {
        console.error('Error fetching footer settings:', error);
      }
    };
    fetchFooterSettings();
  }, []);

  return (
    <footer className="bg-gray-900 text-white py-4 md:py-4">
      <div className="container mx-auto px-4">
        {/* Mobile: Compact single-column layout */}
        <div className="md:hidden">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-gray-300">
            <a href={`tel:${footerSettings.footer_phone.replace(/\s/g, '')}`} className="flex items-center gap-1 hover:text-white">
              <Phone className="w-3 h-3" />
              <span>{footerSettings.footer_phone}</span>
            </a>
            <span className="text-gray-600">|</span>
            <a href={`mailto:${footerSettings.footer_email}`} className="flex items-center gap-1 hover:text-white">
              <Mail className="w-3 h-3" />
              <span>{footerSettings.footer_email}</span>
            </a>
          </div>
          <p className="text-gray-500 text-xs text-center mt-2">
            © {new Date().getFullYear()} {footerSettings.footer_copyright}
          </p>
        </div>

        {/* Desktop: Compact centered single line */}
        <div className="hidden md:flex md:items-center md:justify-center md:gap-4 text-sm">
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4 text-gray-400" />
            <span className="text-gray-300">{footerSettings.footer_address}</span>
          </div>
          <span className="text-gray-600">|</span>
          <div className="flex items-center gap-2">
            <Phone className="w-4 h-4 text-gray-400" />
            <a href={`tel:${footerSettings.footer_phone.replace(/\s/g, '')}`} className="text-gray-300 hover:text-white">
              {footerSettings.footer_phone}
            </a>
          </div>
          <span className="text-gray-600">|</span>
          <div className="flex items-center gap-2">
            <Mail className="w-4 h-4 text-gray-400" />
            <a href={`mailto:${footerSettings.footer_email}`} className="text-gray-300 hover:text-white">
              {footerSettings.footer_email}
            </a>
          </div>
          <span className="text-gray-600">|</span>
          <span className="text-gray-500">© {new Date().getFullYear()} {footerSettings.footer_copyright}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
